import { render, staticRenderFns } from "./PreviousIllnesses.vue?vue&type=template&id=d2e46552"
import script from "./PreviousIllnesses.vue?vue&type=script&lang=js"
export * from "./PreviousIllnesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports